import "@/App.css";
import { Hero, BigIdea, Model100k, TheBook, OldNew, Scoreboard, WhoFor, FinalClose } from "@/components/landing/Sales";
import { DbestDrawn, CaseStudies } from "@/components/landing/Method";
import { Bootcamp, BuildWithDasha } from "@/components/landing/Offers";
import { DmButton } from "@/components/landing/DmButton";
import { NextPaths } from "@/components/landing/Paths";
import { useViewer } from "@/components/landing/viewerStore";
import { Footer } from "@/components/landing/Sections";
import { useEffect } from "react";
import { track } from "@/components/landing/track";
import StatsPage from "@/pages/StatsPage";

const isStats = () => window.location.pathname.replace(/\/+$/, "") === "/stats";

function App() {
  return isStats() ? <StatsPage /> : <Landing />;
}

function Landing() {
  const { email } = useViewer();
  useEffect(() => { track("landed"); }, []);
  return (
    <main className="page">
      <Hero />
      <NextPaths />
      <BigIdea />
      <Model100k />
      <TheBook />
      <OldNew />
      <DbestDrawn />
      <CaseStudies />
      <Scoreboard />
      <WhoFor />
      {email && <Bootcamp />}
      {email && <BuildWithDasha />}
      <FinalClose />
      <Footer />
      <DmButton />
    </main>
  );
}

export default App;
